import React from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'

const Terms = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <h2 className='normal font__size--72 text__70-1024 text__70-md text__70-sm text__70-xxs '><span className='medium'>SUBSCRIPTION TERMS </span> & CONDITIONS</h2>
                    <p className='normal font__size--16 text__16-1024 color__gray-2 mb-5'>Last updated November 28, 2025</p>

                    <div className="mb-5">
                        <h3 className='medium font__size--32 text__32-1024 text__32-xs mb-3'>Agreement to term</h3>
                        <p className='medium font__size--16 text__16-1024 mb-3'>Agreeing to the subscription terms and conditions is a mandatory
requirement to begin using the nutrition program services.
By subscribing to the service, you agree to the following terms and
conditions:
No refunds will be issued once payment is done and the subscription
has started.
The service cannot be transferred to another person.
Subscription freezing policy:
3-month plan: Can be frozen for up to 1 month.
6-month plan: Can be frozen for up to 2 months.</p>
                    </div>


                   </div>
            </section>

            <Footer />
        </div>
    )
}

export default Terms